<!--
 * @Author: ZhaoG
 * @Date: 2026-03-05 14:37:47
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-06 15:41:30
 * @FilePath: \sra-fe\src\views\common\matcateryDialog.vue
 * @Description:设备物资编码参照
-->

<template>
  <div class="el-material-selector">
    <el-dialog
      maxHeight="null"
      width="990px"
      :title="
        shebeioryunshu == 'tran' ? '运输设备物资编码' : '设备物资编码参照'
      "
      @close="close"
      :visible.sync="dialogFormVisible1"
      custom-class="sorting-code-number"
    >
      <div class="el-dialog__body-bodys" v-if="dialogFormVisible1">
        <div class="container">
          <div class="header">已选择({{ selectData.length }}个)</div>
          <div class="ccui-multifunctional-table-wrapper">
            <el-table
              :data="selectData"
              ref="multipleTable2"
              maxHeight="150"
              class="dic-select-table"
              border
              :fit="true"
              row-key="matcodeNum"
            >
              <el-table-column
                label="序号"
                :width="materialCodeDialogWidth.serialNoWidth"
                fixed
              >
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column
                v-for="(table, index) in tableTheadOptions"
                :key="index"
                :fixed="table.fixed || false"
                :label="table.label"
                :width="table.width"
                :min-width="table['min-width']"
                :prop="table.prop"
                show-overflow-tooltip
              >
              </el-table-column>

              <el-table-column label="操作" width="60px">
                <template slot-scope="{ row, $index }">
                  <el-button
                    size="mini"
                    type="text"
                    @click="inventoryDeleteTable(row, $index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="container">
          <div class="search-top">
            <span>请选择设备物资编码类别，进行模糊查询</span>
            <el-search
              :formProp="formData"
              :showIndex="0"
              width="400px"
              placement="bottom-start"
              @search="search"
              @change="change"
            >
              <template slot="search">
                <!--                <el-input-->
                <!--                  v-model="formData.matcodeNum"-->
                <!--                  clearable-->
                <!--                  searchLabel="设备物资编码"-->
                <!--                  placeholder="请输入设备物资编码模糊查询"-->
                <!--                ></el-input>-->
                <el-input
                  v-model="formData.matcodeName"
                  clearable
                  searchLabel="设备物资名称"
                  placeholder="请输入设备物资名称模糊查询"
                ></el-input>
              </template>
            </el-search>
          </div>
          <div>
            <div class="treeTable">
              <el-tree
                :props="treeProps"
                :load="loadNode"
                ref="tree"
                node-key="onlyId"
                expand-on-click-node
                @check="handleCheckClick"
                @node-click="handlenNodeClick"
                :default-checked-keys="defaultCheckedKeys"
                lazy
                show-line
              >
              </el-tree>
            </div>
            <div class="bodys-right ccui-multifunctional-table-wrapper">
              <el-table
                v-loading="loading"
                :data="tableData"
                height="200"
                ref="dataTable"
                :row-key="getRowKeys"
                :lineClamp="lineClampBody"
                style="width: 735px"
                @select="handleSelect"
                @select-all="handleSelectAll"
                border
                v-if="type == 1"
              >
                <el-table-column
                  type="selection"
                  :reserve-selection="true"
                  fixed="left"
                  :width="materialCodeDialogWidth.selectionA"
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  label="序号"
                  type="index"
                  align="center"
                  fixed="left"
                  :width="materialCodeDialogWidth.serialNoWidth"
                />
                <el-table-column
                  prop="matcodeNum"
                  :show-overflow-tooltip="true"
                  label="设备物资编码"
                  :min-width="materialCodeDialogWidth.matcodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcodeName"
                  show-overflow-tooltip
                  label="设备物资名称"
                  :width="materialCodeDialogWidth.matcodeName"
                >
                </el-table-column>
                <el-table-column
                  prop="matTagName"
                  show-overflow-tooltip
                  label="管理类型"
                  :width="materialCodeDialogWidth.matcodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcateryCode"
                  show-overflow-tooltip
                  label="分类编码"
                  :width="materialCodeDialogWidth.classCodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcateryName"
                  :show-overflow-tooltip="true"
                  label="分类名称"
                  :min-width="materialCodeDialogWidth.minClassName"
                >
                </el-table-column>
                <el-table-column
                  prop="unitName"
                  show-overflow-tooltip
                  label="计量单位"
                  :width="materialCodeDialogWidth.unitName"
                >
                </el-table-column>
              </el-table>
              <el-table
                v-else
                v-loading="loading"
                :data="tableData"
                height="200"
                ref="dataTable"
                :row-key="getRowKeys"
                :lineClamp="lineClampBody"
                style="width: 735px"
                class="dic-select-table"
                border
                @select="handleSelect"
                @select-all="handleSelectAll"
              >
                <!-- <el-table-column
                  type="selection"
                  width="55"
                  :reserve-selection="true"
                /> -->
                <el-table-column
                  :width="materialCodeDialogWidth.selectionB"
                  align="center"
                  label="选择"
                >
                  <template slot-scope="scope">
                    <el-radio
                      :label="scope.$index"
                      v-model="selectFlag"
                      @change.native="handleRowChange(scope.$index, scope.row)"
                      style="margin-left: 10px;"
                      >{{ "" }}</el-radio
                    >
                  </template>
                </el-table-column>

                <el-table-column
                  :show-overflow-tooltip="true"
                  label="序号"
                  type="index"
                  align="center"
                  :width="materialCodeDialogWidth.serialNoWidth"
                />
                <el-table-column
                  prop="matcodeNum"
                  :show-overflow-tooltip="true"
                  label="设备物资编码"
                  :min-width="materialCodeDialogWidth.matcodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcodeName"
                  :show-overflow-tooltip="true"
                  label="设备物资名称"
                  :width="materialCodeDialogWidth.matcodeName1"
                >
                </el-table-column>
                <el-table-column
                  prop="matTagName"
                  show-overflow-tooltip
                  label="管理类型"
                  :width="materialCodeDialogWidth.matcodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcateryCode"
                  :show-overflow-tooltip="true"
                  label="分类编码"
                  :width="materialCodeDialogWidth.classCodeNum"
                >
                </el-table-column>
                <el-table-column
                  prop="matcateryName"
                  :show-overflow-tooltip="true"
                  label="分类名称"
                  :min-width="materialCodeDialogWidth.minClassName"
                >
                </el-table-column>
                <el-table-column
                  prop="unitName"
                  :show-overflow-tooltip="true"
                  label="计量单位"
                  :width="materialCodeDialogWidth.unitName"
                >
                </el-table-column>
              </el-table>
              <div class="table-footer" style="height:30px" v-show="isTurnPage">
                <div class="ccui-table-footer">
                  <div id="ccui-paging">
                    <el-pagination
                      :total="total"
                      :pager-count="5"
                      :page-size="formData.pageSize"
                      :current-page="formData.pageNo"
                      prev-text="< 上一页"
                      next-text="下一页 >"
                      background
                      layout="total, sizes, prev, pager, next, jumper"
                      popper-class="ccui-paging-page-size-popper"
                      @prev-click="handlePrev"
                      @next-click="handleNext"
                      @size-change="handleSizeChange"
                      @addCurrentPage="internalCurrentPage"
                      @current-change="handleCurrentChange"
                    />
                    <el-button
                      class="ccui-pagination-btn"
                      size="mini"
                      type="default"
                      @click="handleGoPage"
                      >确定</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="cancel"
          >取 消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="handleTrue"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Cookies from "js-cookie";
import { generateUUID } from "@/utils";
import {
  qryMatcateryTreeList,
  qryMatcateryCodeList,
  qryUsedMatcateryTypeList,
  qryUsedMatcodeListApi
} from "@/api/supRegister";
import {
  materialCodeDialogWidth
} from "@/setting/setting";

export default {
  name: "materialDirectory",
  watch: {
    dialogFormVisible(item) {
      if (item) {
        this.tableData = [];
        this.selectData = [];
        this.materialsData = [];
        this.isTurnPage = false;
        this.formData = {
          pageNo: 1,
          pageSize: 10,
          matcateryLevel: "",
          matcateryCode: "",
          matcodeNum: "",
          matcateryAlias: "",
          matcodeName: ""
        };
        this.isChooseCommonCode = true;
        this.loading = true;
        // this.qryUsedMatcodeList({
        //   matcodeNum: "",
        //   matcodeName: "",
        //   unitId: this.opUnitId,
        //   pageNo: 1,
        //   pageSize: 10
        // });
      }
      this.dialogFormVisible1 = item;
    }
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Object,
      default: () => {
        return {
          APP_TOKEN: Cookies.get("appToken"),
          Authorization: Cookies.get("access_token")
        };
      }
    },
    shebeioryunshu:{
      type:String,
      default:""
    },
    type:{
       type: Number,
      default: 1,//1多选，2单选
    },
    opUnitId: {
      type:String,
      default:""
    }
  },
  activated() {
  },
  created() {},
  data() {
    return {
      materialCodeDialogWidth:materialCodeDialogWidth,
      lineClampBody: true,
      loading: false,
      dialogFormVisible1: this.dialogFormVisible,
      conditionCheckbox: true,
      tableData: [],
      treeProps: {
        label: "name",
        children: "qryMatcateryTreeBOList",
        isLeaf: "leaf"
      },
      gridData: [],
      dialogTableVisibletextarea: false,
      formData: {
        pageNo: 1,
        pageSize: 10,
        matcateryLevel: "",
        matcateryCode: "",
        matcodeNum: "",
        matcateryAlias: "",
        matcodeName: ""
      },
      textarea: "",
      formLabelWidth: "120px",
      present: "",
      total: 0,
      lastTime: {
        button: false
      },
      materialsData: [], // 物资选择数据
      isTurnPage: false, // 是否有翻页
      treeArray: [],
      isChooseCommonCode: false, // 是否选中的常用物资编码
      selectData: [],
      tableTheadOptions: [
        {
          prop: "matcodeNum",
          label: "设备物资编码",
          'min-width': materialCodeDialogWidth.matcodeNum
        },
        {
          prop: "matcodeName",
          label: "设备物资名称",
          width: materialCodeDialogWidth.matcodeName
        },
        {
          prop: "matTagName",
          label: "管理类型",
          width: materialCodeDialogWidth.matcodeNum
        },
        { prop: "matcateryCode",
          label: "分类编码",
          width:materialCodeDialogWidth.classCodeNum
        },
        { prop: "matcateryName", label: "分类名称",'min-width': materialCodeDialogWidth.minClassName },
        { prop: "unitName", label: "计量单位", width: materialCodeDialogWidth.unitName }
      ],
      isTrueClick:true,
      defaultCheckedKeys: [0],
      selectFlag:false
    };
  },
  methods: {
    getRowKeys(row) {
      return row.matcodeNum;
    },
    handleSizeChange(val) {
      this.formData.pageNo = 1;
      this.formData.pageSize = val;
      this.loading = true;
      if (this.isChooseCommonCode) {
        this.qryUsedMatcodeList({
          matcodeNum: this.formData.matcodeNum,
          matcodeName: this.formData.matcodeName,
          unitId: this.opUnitId,
          pageNo: 1,
          pageSize: val
        });
      } else {
        this.loading = true;
        this.qryListMateriaCata();
      }
    },
    close() {
      this.$emit("update:dialogFormVisible", false);
    },
    cancel() {
      this.$emit("update:dialogFormVisible", false);
    },
    // 树复选框
    handleCheckClick(checkedNodes, checkedKeys) {
      this.$refs.tree.setCheckedKeys([]);
      this.defaultCheckedKeys = [];
      checkedKeys.checkedKeys.forEach(i => {
        this.materialsData = this.materialsData.filter(e => {
          return e.categoryCode !== i;
        });
      });
      this.$nextTick(() => {
        this.$refs.dataTable.clearSelection();
        this.$refs.tree.setCheckedKeys([]);
        // this.tableData.map(row => {
        //   this.materialsData.map(i => {
        //     if(i.categoryCode === row.categoryCode && i.matCode === row.matCode){
        //       // this.$refs.dataTable.toggleRowSelection(row,true);
        //     }
        //   })
        // })
      });
    },
    handlenNodeClick(checkedNodes) {

      this.$refs.tree.setCheckedKeys([]);
      this.defaultCheckedKeys = [];
      this.formData.matcodeNum = "";
      this.formData.matcodeName = ""
      this.isChooseCommonCode = false;
      if (checkedNodes.id === "commonCoding") {
        this.isChooseCommonCode = true;
        this.loading = true;
        this.qryUsedMatcodeList({
          matcodeNum: "",
          matcodeName: "",
          unitId: this.opUnitId,
          pageNo: 1,
          pageSize: 10
        });
      } else if (
        checkedNodes.id != "commonlyUsedCategories" &&
        checkedNodes.id != "equipmentMaterialsCategory"
      ) {
        // if (checkedNodes.leaf) {
          this.loading = true;
          this.formData.matcateryCode = checkedNodes.id;
          this.formData.matcateryLevel = checkedNodes.matcateryLevel;
          this.formData.pageNo = 1;
          this.qryListMateriaCata();
        // }
      }
    },
    qryListMateriaCata() {
      this.formData.unitId = this.opUnitId;
      console.log();
      qryMatcateryCodeList(this.formData).then(res => {
        if (res.data.code === "0") {
          this.selectFlag=false;
          this.tableData = res.data.data.rows;
          this.total = res.data.data.recordsTotal;
          // this.$nextTick(() => {
          //   if (this.tableData.length === 0) {
          //     this.isTurnPage = false;
          //   } else {
          //     this.isTurnPage = true;
          //   }
          // });
          // 梁青竹更改如下
          this.$nextTick(() => {
            if (this.tableData.length === 0) {
              this.isTurnPage = false;
            } else {
              this.isTurnPage = true;
            }
            this.tableData.forEach(row => {
              this.$refs.dataTable.toggleRowSelection(row, false);
              this.selectData.forEach(i => {
                if (
                  i.matcodeNum === row.matcodeNum &&
                  i.matcateryCode === row.matcateryCode
                ) {
                  this.$refs.dataTable.toggleRowSelection(row, true);
                }
              });
            });
            this.loading = false;
          });
        }
      });
    },
    // 用于查询设备物资分类列表。
    qryUsedMatcodeList(param) {
      // param.notLikeMatcateryCode = "1346";
      qryUsedMatcodeListApi(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.recordsTotal;
          // this.$nextTick(() => {
          //   if (this.tableData.length === 0) {
          //     this.isTurnPage = false;
          //   } else {
          //     this.isTurnPage = true;
          //   }
          // });
          // this.$nextTick(() => {
          //   if (this.tableData.length === 0) {
          //     this.isTurnPage = false;
          //   } else {
          //     this.isTurnPage = true;
          //   }
          // });
          // 梁青竹更改如下
          this.$nextTick(() => {
            if (this.tableData.length === 0) {
              this.isTurnPage = false;
            } else {
              this.isTurnPage = true;
            }
            this.tableData.forEach(row => {
              this.$refs.dataTable.toggleRowSelection(row, false);
              this.selectData.forEach(i => {
                if (
                  i.matcodeNum === row.matcodeNum &&
                  i.matcateryCode === row.matcateryCode
                ) {
                  this.$refs.dataTable.toggleRowSelection(row, true);
                }
              });
            });
            this.loading = false;
          });
        }
      });
    },
    // 列表复选框全选
    handleSelectAll(selection) {
      if (selection.length < this.selectData.length) {
        // 取消全选
        let arr = JSON.parse(JSON.stringify(this.selectData));
        this.selectData = [...arr].filter(item =>
          [...this.tableData].every(
            aItem => aItem.matcodeNum != item.matcodeNum
          )
        );
      } else {
        this.materialsData = JSON.parse(JSON.stringify(selection));
        let newArr = [...[], ...this.selectData, ...this.materialsData];
        let arr = new Map();
        this.selectData = newArr.filter(
          item => !arr.has(item.matcodeNum) && arr.set(item.matcodeNum, 1)
        );
        this.$emit("handleSelectAll", selection);
      }

      this.$nextTick(()=>{
        this.$refs.multipleTable2.doLayout();
      })

    },
    setHalfCheckedNodes(key) {
      const node = this.$refs["tree"].getNode(key);
      if (node) {
        node.indeterminate = true;
      }
    },

    handleRowChange(index,row){
      let data=[row]
      this.materialsData = data;
      this.selectData = data;
    },
    // 列表复选框单选
    handleSelect(row, data) {
        let index = this.selectData.findIndex(n => {
          return n.matcodeNum === data.matcodeNum;
      });
        if (index === -1) {
          this.selectData.push(data);
          this.materialsData.push(data);
      } else {
          this.selectData.splice(index, 1);
         this.materialsData.splice(index, 1);
      }

      this.$nextTick(()=>{
        this.$refs.multipleTable2.doLayout();
      })


      // let newArr = [...[],...this.selectData,...this.materialsData];
      // let arr = new Map();
      // this.selectData = newArr.filter((item) => !arr.has(item.matcodeNum) && arr.set(item.matcodeNum, 1))
      // this.$refs.tree.setChecked(data.categoryCode, false);
      // this.$emit('handleSelect', row);
      // this.$nextTick(() => {
      //   if (row.length === 0) {
      //     this.$refs.tree.setChecked(data.categoryCode, false);
      //   }
      //   this.materialsData.map(i => {
      //     this.setHalfCheckedNodes(i.categoryCode);
      //   })
      // });
    },
    handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.loading = true;
      if (this.isChooseCommonCode) {
        this.qryUsedMatcodeList({
          matcodeNum: this.formData.matcodeNum,
          matcodeName: this.formData.matcodeName,
          unitId: this.opUnitId,
          pageNo: val,
          pageSize: 10
        });
      } else {
        this.loading = true;
        this.qryListMateriaCata();
      }
    },
    internalCurrentPage(val) {
      this.formData.pageNo = val;
      if (this.isChooseCommonCode) {
        this.qryUsedMatcodeList({
          matcodeNum: this.formData.matcodeNum,
          matcodeName: this.formData.matcodeName,
          unitId: this.opUnitId,
          pageNo: val,
          pageSize: 10
        });
      } else {
        this.loading = true;
        this.qryListMateriaCata();
      }
    },
    handlePrev(val) {},
    handleNext(val) {},
    handleGoPage() {},
    loadNode(node, resolve) {
      if (node.level === 0) {
        let parent = [
          // {
          //   id: "commonCoding",
          //   qryMatcateryTreeBOList: [],
          //   name: "常用编码",
          //   leaf: true,
          //   topCode: 0,
          //   unitName: "常用编码",
          //   unitCode: "0",
          //   onlyId: 0
          // },
          {
            id: "equipmentMaterialsCategory",
            qryMatcateryTreeBOList: [],
            name: "设备物资类别",
            leaf: false,
            topCode: 0,
            unitName: "设备物资类别",
            unitCode: "0",
            onlyId: 1
          },
          // {
          //   id: "commonlyUsedCategories",
          //   qryMatcateryTreeBOList: [],
          //   name: "常用类别",
          //   leaf: false,
          //   topCode: 0,
          //   unitName: "常用类别",
          //   unitCode: "0",
          //   onlyId: 2
          // }
        ];
        resolve(parent);
      } else if (node.level === 1) {
        if (node.data.id === "equipmentMaterialsCategory") {
          // 设备物资类别
          qryMatcateryTreeList({
            parentMatcateryCode: "00"
          }).then(res => {
            // const nodes = res.data.data.qryMatcateryTreeBOList.map(item => ({
            const nodes = res.data.data.map(item => ({
              id: item.matcateryCode,
              qryMatcateryTreeBOList: [],
              name: item.matcateryName,
              leaf: item.isOrder != 0,
              topCode: item.parentMatcateryCode,
              unitName: item.unitName,
              unitCode: item.unitCode,
              matcateryLevel: item.matcateryLevel,
              onlyId: generateUUID()
            }));
            resolve(nodes);
          });
        }
        if (node.data.id === "commonlyUsedCategories") {
          // 常用类别
          qryUsedMatcateryTypeList({
            matcateryCode: "",
            matcateryName: "",
            // notLikeMatcateryCode:"1346"
          }).then(res => {
            const nodes = res.data.data.rows.map(item => ({
              id: item.matcateryCode,
              qryMatcateryTreeBOList: [],
              name: item.matcateryName,
              leaf: true,
              topCode: item.matcateryCodeMid,
              matcateryLevel: item.matcateryLevel,
              onlyId: generateUUID()
            }));
            resolve(nodes);
          });
        }
      } else {
        qryMatcateryTreeList({
          parentMatcateryCode: node.data.id,
          matcateryLevel: node.data.matcateryLevel
        }).then(res => {
          // const nodes = res.data.data.qryMatcateryTreeBOList.map(item => ({
            // let arr = res.data.data.filter(item=>item.matcateryCode!='1346')
            let arr = res.data.data
          const nodes = arr.map(item => ({
            id: item.matcateryCode,
            name: item.matcateryName,
            qryMatcateryTreeBOList: [],
            leaf: item.isOrder != 0,
            topCode: item.parentMatcateryCode,
            unitName: item.unitName,
            unitCode: item.unitCode,
            matcateryLevel: item.matcateryLevel,
            onlyId: generateUUID()
          }));
          resolve(nodes);
        });
      }
      if (node.level > 1) return resolve([]);
    },
    search(val) {
      this.$refs.tree.setCheckedKeys([]);
      if (this.isChooseCommonCode) {
        this.qryUsedMatcodeList({
          matcodeNum: this.formData.matcodeNum,
          matcodeName: this.formData.matcodeName,
          unitId: this.opUnitId,
          pageNo: 1,
          pageSize: 10
        });
      } else {
        this.loading = true;
        this.formData.pageNo = 1;
        this.qryListMateriaCata();
      }
    },
    change(val) {
      if (val === 0) {
        this.formData.matcodeName = "";
      } else {
        this.formData.matcateryCode = "";
        this.formData.matcodeNum = "";
      }
    },
    // 删除
    inventoryDeleteTable(row, index) {
      this.selectData = this.selectData.filter(
        item => item.matcodeNum !== row.matcodeNum
      );
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.$refs.dataTable.toggleRowSelection(item, false);
        });
        this.tableData.forEach(row => {
          this.selectData.forEach(i => {
            if (
              i.matcodeNum === row.matcodeNum &&
              i.matcateryCode === row.matcateryCode
            ) {
              this.$refs.dataTable.toggleRowSelection(row, true);
            }
          });
        });
      });
    },
    handleTrue() {
      if(!this.isTrueClick){
        return
      }
      // let treeData = this.$refs.tree.getCheckedNodes(true);
      // let data = [...treeData, ...this.materialsData];
      // this.$emit('handleTrue', data);
      this.selectFlag=false
      this.isTrueClick=false//防重点击
      this.$emit("handleTrue", this.selectData,this.shebeioryunshu);
      this.$emit("update:dialogFormVisible", false);
      setTimeout(()=>{
        this.isTrueClick=true
      },2000)
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .container:nth-child(2) {
 margin-top: 10px;
}
.container {
  .header {
    margin-bottom: 10px;
  }
  .table-footer {
    padding: 10px 0;
  }
  .ccui-statistics-card {
    padding: 0;
  }
}
.treeTable {
  width: 200px;
  height: 254px;
  overflow: auto;
  border: 1px solid #f1f1f1;
  float: left;
}
/deep/ .el-search .ccui-search-wrapper {
  margin-bottom: 0px !important;
}
/deep/ .el-tree-node.is-current > .el-tree-node__content span,
/deep/ .el-tree-node.is-checked > .el-tree-node__content span {
  color: #0089ef !important;
}
.bodys-right {
  /deep/ .el-table {
    .el-table__header {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
      td .cell {
        width: 100% !important;
      }
    }
    th .gutter {
      display: table-cell !important;
    }
  }
}
.ccui-multifunctional-table-wrapper {
  /deep/ .el-table .el-table__body tr td .cell {
    padding-left: 10px !important;
    -webkit-line-clamp: 1 !important;
  }
}
.el-material-selector
  .sorting-code-number
  .el-dialog__body
  .el-dialog__body-bodys
  .bodys-right.ccui-multifunctional-table-wrapper {
  /deep/ .el-table .el-table__body tr td {
    padding: 0 !important;
  }
 /deep/ .cell{
    font-size: 13px;
  }
}
.el-material-selector {
  /deep/ .el-table__empty-block {
    min-height: 110px;
  }
}
/deep/.ccui-multifunctional-table-wrapper .el-table td {
  border-right: 1px solid #edf2fc!important;
}
/deep/ .ccui-multifunctional-table-wrapper .el-table th {
  border-right: 1px solid #edf2fc!important;
}
/deep/.ccui-multifunctional-table-wrapper .ccui-table-footer {
  padding-top: 0;
}
/deep/.ccui-multifunctional-table-wrapper .el-table__body-wrapper {
  height:160px !important;
}
// /deep/ colgroup col:last-child {
//   width: 24px !important; //此处的宽度值，对应你自定义滚动条的宽度即可
//   display: block!important;
// }
/deep/.ccui-multifunctional-table-wrapper .el-table td {
  border-bottom: 1px solid #edf2fc!important;
}
// 解决表格超出部分出现省略号 但是不显示省略的内容bug
/deep/ .ccui-multifunctional-table-wrapper .el-table .cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}

.container {
  .search-top {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px 0;
    span {
      color: #f53f3f;
      font-size: 16px;
      margin-right: 30px;
    }
  }
}
/deep/ .el-loading-spinner{
  top: 50%;
  left: 50%;
  position: absolute;
  background: rgba(51,51,51,.56);
  border-radius:2px;
}
</style>
